import {
  type GetProjectSettingsQuery,
  type OurWorkBudgetItem,
  type Project,
  ProjectTypeEnum,
  type TimeTrackingBudgetItem,
} from "@src/__generated__/graphql";

type TProject = NonNullable<GetProjectSettingsQuery["project"]>;

type TTimeTrackingRate = NonNullable<
  GetProjectSettingsQuery["project"]
>["timeTrackingRates"][0];

type TOurWorkItem = NonNullable<TProject["ourWork"]>[0];
type TTimeTrackingSetting = NonNullable<TOurWorkItem["timeTrackingSettings"]>;

export class ProjectSettingsModel {
  id: TProject["id"];
  code: TProject["code"];
  title: TProject["title"];
  brand: TProject["brand"];
  billable: TProject["billable"];
  average_time_tracking_rate: Project["average_time_tracking_rate"];
  calculated_average_time_tracking_rate: Project["calculated_average_time_tracking_rate"];
  timeTrackingRates: TimeTrackingRateModel[];
  ourWork: OurWorkItemModel[];
  uses_budgetovac: Project["uses_budgetovac"];
  finished_at: TProject["finished_at"];
  rate_card_exchange_rate: Project["rate_card_exchange_rate"];
  budget_id?: string | null;
  isTimeAndMaterials: boolean;

  constructor(src: TProject) {
    this.id = src.id;
    this.code = src.code;
    this.title = src.title;
    this.brand = src.brand;
    this.isTimeAndMaterials = src.type === ProjectTypeEnum.TimeMaterials;
    this.billable = src.billable;
    this.average_time_tracking_rate = src.average_time_tracking_rate;
    this.timeTrackingRates = src.timeTrackingRates.map(
      (rate) => new TimeTrackingRateModel(rate),
    );
    this.ourWork = src.ourWork.map((i) => new OurWorkItemModel(i));
    this.uses_budgetovac = src.uses_budgetovac;
    this.finished_at = src.finished_at;
    this.rate_card_exchange_rate = src.rate_card_exchange_rate;
    this.budget_id = src.budgetovacBudget?.budget_id;
    this.calculated_average_time_tracking_rate =
      src.calculated_average_time_tracking_rate;
  }
}

export class TimeTrackingRateModel {
  rate: TTimeTrackingRate["rate"];
  timeTrackingWorkType: {
    id: string;
    default_rate: number;
    title: string;
  };

  constructor(src: TTimeTrackingRate) {
    this.rate = src.rate;
    this.timeTrackingWorkType = src.timeTrackingWorkType;
  }
}

export class OurWorkItemModel {
  id: string;
  title: OurWorkBudgetItem["title"];
  timeTrackingSettings: TimeTrackingSettingsModel;
  categoryName: OurWorkBudgetItem["category"]["name"];

  constructor(src: TOurWorkItem) {
    this.id = src.id;
    this.title = src.title;
    this.timeTrackingSettings = new TimeTrackingSettingsModel(
      src.timeTrackingSettings,
    );
    this.categoryName = src.category.name;
  }
}

class TimeTrackingSettingsModel {
  id: string;
  tracking_enabled_from?: Date;
  tracking_enabled_to?: Date;
  tracking_enabled: TimeTrackingBudgetItem["tracking_enabled"];

  constructor(src: TTimeTrackingSetting) {
    this.id = src.id;
    this.tracking_enabled_from = src.tracking_enabled_from
      ? new Date(src.tracking_enabled_from)
      : undefined;
    this.tracking_enabled_to = src.tracking_enabled_to
      ? new Date(src.tracking_enabled_to)
      : undefined;
    this.tracking_enabled = src.tracking_enabled;
  }
}
